<template lang="pug">
  SspLayout.create-order(area="core")
    .col-md-12
      SspSaveForm(@onSubmit="save" :saving="saving")
        .form-horizontal
          .form-group
            label.col-sm-4.control-label Name
            .col-sm-8
              input.order-name.form-control(type="text" placeholder="Order Name" v-model="description")
          .form-group
            label.col-sm-4.control-label Product
            .col-sm-8
              ProductSelect(v-model="productId")
          .form-group
            label.col-sm-4.control-label Metadata Schema
            .col-sm-8
              MetadataSchemaSelect(v-model="metadataId")
</template>

<script>
import ProductSelect from '@/components/ssp/ProductSelect'
import Core from '@/service/apis/Core'
import MetadataSchemaSelect from '@/components/ssp/MetadataSchemaSelect'

export default {
  data: () => ({
    saving: false,
    description: null,
    productId: null,
    metadataId: null
  }),
  methods: {
    save() {
      this.saving = true
      const req = {
        description: this.description,
        sectioned: true
      }

      if (this.productId) {
        req.product = {
          id: this.productId
        }
      }
      if (this.metadataId) {
        req.metadata = {
          schema: {
            id: this.metadataId
          }
        }
      }
      Core.createOrder(req)
        .then(() => {
          this.$router.push({ name: 'orders' })
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    }
  },
  components: {
    ProductSelect,
    MetadataSchemaSelect
  }
}
</script>

<style lang="scss">
.double {
  zoom: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/OrderCreate.vue